import { Mutations } from './types'
import Recipe from '@/store/models/Recipe'

export default {
  [Mutations.STORE_RECIPES](state, recipes) {
    recipes.forEach(recipe => state.push(new Recipe(recipe)))
  }
}
